import './Icon_Profile.css';
import {ReactComponent as ProfileIcon} from './Icons_Avatar_Outline_Brand.svg'
function Icon_Profile() {
  return (
    <div className='icon-container-profile'>
   <ProfileIcon className="responsive-svg-profile" />
    </div>
  );
}

export default Icon_Profile;